<div class="nepf-pref-row" [formGroup]="formGroup">
  <div class="nepf-pref-row__icon" aria-hidden="true">
    <mat-icon>{{ eventIcon }}</mat-icon>
  </div>

  <div class="nepf-pref-row__copy">
    <span class="nepf-pref-row__event-label">{{ eventLabel }}</span>
    @if (eventDescription) {
      <span class="nepf-pref-row__event-desc">{{ eventDescription }}</span>
    }
  </div>

  <div class="nepf-pref-row__controls">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="nepf-pref-row__field">
      <mat-label>Channel</mat-label>
      <mat-select formControlName="channel" [attr.aria-label]="'Channel for ' + eventLabel">
        @for (opt of channelOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="nepf-pref-row__field">
      <mat-label>Mode</mat-label>
      <mat-select formControlName="mode" [attr.aria-label]="'Mode for ' + eventLabel">
        @for (opt of modeOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
